import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { DomainContext } from '../../domain-repository/DomainRepository'

import { saveSessionEnd, setPageId } from '../../services/Metrics'

import withLang from '../../withLang'
import { session } from '../../load-config'
import TrackingPage from '../../components/TrackingPage'

function ThankYouPage(props) {
  const { t } = useTranslation()

  const {
    reservation,
    notifyResult,
    setSessionId,
  } = useContext(DomainContext)

  const sessionId = session.getSessionId()
  
  const [savedSessionId, setSavedSessionId] = useState(sessionId)

  useEffect(() => {
    setPageId({ pageId: 26 })
    saveSessionEnd(false)
  }, [])

  function getNotificationMessage() {
    const { wasEmailSent, wasSMSSent } = notifyResult

    if (wasEmailSent && wasSMSSent) {
      return t('thankYouEmailAndSMSSentMobile')
    }
    if (wasEmailSent && !wasSMSSent) {
      return t('thankYouEmailSentMobile')
    }
    if (!wasEmailSent && wasSMSSent) {
      return t('thankYouSMSSentMobile')
    }
    return t('thankYouEmailAndSMSSentMobile')
  }

  const notificationMessage = notifyResult ? getNotificationMessage() : null

  return (
    <div className="container light-green-bg">
      <div className="row justify-content-center text-center">
        <div className="col-5 mt-5">
          <div>
            <img onClick={() => props.history.push('/start')} src={require(`../../assets/images/logo.png`)} alt="Guerin" className="img-fluid pt-3 pb-3" />
          </div>
        </div>
      </div>
      <div className="text-center light-green-bg">
        <div className="resumo-header">
          <h2 className="title"><b>{t('thankYouForYourPreference')}</b></h2>
          <h2 className="title">{t('thankYouReservationUpdate')}</h2>
          <h2 className="title"><b>{reservation ? reservation.Reservation : ''}</b></h2>
          <p className="p-4 color-grey font-weight-light">{notificationMessage}</p>
        </div>
      </div>
      <div className="finish-button" onClick={() => props.history.push(`/rating`)}>
        {t('opinionButton')}
      </div>
    </div>
  )
}

export default withLang(TrackingPage(ThankYouPage, 89))
